import { updateYear, updateMonth, updateState, updateEntity } from "./slice";
import { useAppDispatch, useAppSelector } from "app/store";

export const useInsightsFilters = () => {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.insightsFilters);

  return {
    insightsFilters: selector,
    updateYear: (payload: number) => dispatch(updateYear(payload)),
    updateMonth: (payload: string) => dispatch(updateMonth(payload)),
    updateState: (payload: string) => dispatch(updateState(payload)),
    updateEntity: (payload: string) => dispatch(updateEntity(payload)),
  };
};
